import { ref, watch } from 'vue'

export const categoryIdBus = ref<number>(0)
